/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateUsuario = /* GraphQL */ `
  subscription OnCreateUsuario($filter: ModelSubscriptionUsuarioFilterInput) {
    onCreateUsuario(filter: $filter) {
      id
      name
      email
      proyectos {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      logs {
        nextToken
        __typename
      }
      creditos {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      creditosId
      perfil {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        especialidades
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      perfilId
      isActive
      createdAt
      updatedAt
      institucionUsuariosId
      __typename
    }
  }
`;
export const onUpdateUsuario = /* GraphQL */ `
  subscription OnUpdateUsuario($filter: ModelSubscriptionUsuarioFilterInput) {
    onUpdateUsuario(filter: $filter) {
      id
      name
      email
      proyectos {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      logs {
        nextToken
        __typename
      }
      creditos {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      creditosId
      perfil {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        especialidades
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      perfilId
      isActive
      createdAt
      updatedAt
      institucionUsuariosId
      __typename
    }
  }
`;
export const onDeleteUsuario = /* GraphQL */ `
  subscription OnDeleteUsuario($filter: ModelSubscriptionUsuarioFilterInput) {
    onDeleteUsuario(filter: $filter) {
      id
      name
      email
      proyectos {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      logs {
        nextToken
        __typename
      }
      creditos {
        id
        usuarioId
        creditosUsados
        tokensIngresados
        tokensRecibidos
        createdAt
        updatedAt
        __typename
      }
      creditosId
      perfil {
        id
        nombre
        apellido
        tel
        cargo
        RBD
        colegio
        pais
        ciudad
        especialidades
        usuarioId
        createdAt
        updatedAt
        __typename
      }
      perfilId
      isActive
      createdAt
      updatedAt
      institucionUsuariosId
      __typename
    }
  }
`;
export const onCreateControlError = /* GraphQL */ `
  subscription OnCreateControlError(
    $filter: ModelSubscriptionControlErrorFilterInput
  ) {
    onCreateControlError(filter: $filter) {
      id
      browser
      browserVersion
      os
      osVersion
      deviceType
      url
      info
      servicio
      mensaje
      stackTrace
      usuarioId
      sessionId
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateControlError = /* GraphQL */ `
  subscription OnUpdateControlError(
    $filter: ModelSubscriptionControlErrorFilterInput
  ) {
    onUpdateControlError(filter: $filter) {
      id
      browser
      browserVersion
      os
      osVersion
      deviceType
      url
      info
      servicio
      mensaje
      stackTrace
      usuarioId
      sessionId
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteControlError = /* GraphQL */ `
  subscription OnDeleteControlError(
    $filter: ModelSubscriptionControlErrorFilterInput
  ) {
    onDeleteControlError(filter: $filter) {
      id
      browser
      browserVersion
      os
      osVersion
      deviceType
      url
      info
      servicio
      mensaje
      stackTrace
      usuarioId
      sessionId
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCreditos = /* GraphQL */ `
  subscription OnCreateCreditos($filter: ModelSubscriptionCreditosFilterInput) {
    onCreateCreditos(filter: $filter) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      creditosUsados
      tokensIngresados
      tokensRecibidos
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCreditos = /* GraphQL */ `
  subscription OnUpdateCreditos($filter: ModelSubscriptionCreditosFilterInput) {
    onUpdateCreditos(filter: $filter) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      creditosUsados
      tokensIngresados
      tokensRecibidos
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCreditos = /* GraphQL */ `
  subscription OnDeleteCreditos($filter: ModelSubscriptionCreditosFilterInput) {
    onDeleteCreditos(filter: $filter) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      creditosUsados
      tokensIngresados
      tokensRecibidos
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProyecto = /* GraphQL */ `
  subscription OnCreateProyecto($filter: ModelSubscriptionProyectoFilterInput) {
    onCreateProyecto(filter: $filter) {
      id
      name
      tipoEstructura
      nivelCurso
      asignaturas
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      resultados {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      projectUserInputs {
        nextToken
        __typename
      }
      organizacionId
      isCloneProject
      idProyectoFuente
      isEliminated
      createdAt
      updatedAt
      usuarioProyectosId
      institucionProyectosId
      __typename
    }
  }
`;
export const onUpdateProyecto = /* GraphQL */ `
  subscription OnUpdateProyecto($filter: ModelSubscriptionProyectoFilterInput) {
    onUpdateProyecto(filter: $filter) {
      id
      name
      tipoEstructura
      nivelCurso
      asignaturas
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      resultados {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      projectUserInputs {
        nextToken
        __typename
      }
      organizacionId
      isCloneProject
      idProyectoFuente
      isEliminated
      createdAt
      updatedAt
      usuarioProyectosId
      institucionProyectosId
      __typename
    }
  }
`;
export const onDeleteProyecto = /* GraphQL */ `
  subscription OnDeleteProyecto($filter: ModelSubscriptionProyectoFilterInput) {
    onDeleteProyecto(filter: $filter) {
      id
      name
      tipoEstructura
      nivelCurso
      asignaturas
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      resultados {
        nextToken
        __typename
      }
      institucion {
        id
        name
        tipo
        createdAt
        updatedAt
        __typename
      }
      institucionId
      projectUserInputs {
        nextToken
        __typename
      }
      organizacionId
      isCloneProject
      idProyectoFuente
      isEliminated
      createdAt
      updatedAt
      usuarioProyectosId
      institucionProyectosId
      __typename
    }
  }
`;
export const onCreateResultado = /* GraphQL */ `
  subscription OnCreateResultado(
    $filter: ModelSubscriptionResultadoFilterInput
  ) {
    onCreateResultado(filter: $filter) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      resultado
      promptLLM
      in_tokens
      out_tokens
      calificacion
      createdAt
      updatedAt
      proyectoResultadosId
      __typename
    }
  }
`;
export const onUpdateResultado = /* GraphQL */ `
  subscription OnUpdateResultado(
    $filter: ModelSubscriptionResultadoFilterInput
  ) {
    onUpdateResultado(filter: $filter) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      resultado
      promptLLM
      in_tokens
      out_tokens
      calificacion
      createdAt
      updatedAt
      proyectoResultadosId
      __typename
    }
  }
`;
export const onDeleteResultado = /* GraphQL */ `
  subscription OnDeleteResultado(
    $filter: ModelSubscriptionResultadoFilterInput
  ) {
    onDeleteResultado(filter: $filter) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      resultado
      promptLLM
      in_tokens
      out_tokens
      calificacion
      createdAt
      updatedAt
      proyectoResultadosId
      __typename
    }
  }
`;
export const onCreateProjectUserInput = /* GraphQL */ `
  subscription OnCreateProjectUserInput(
    $filter: ModelSubscriptionProjectUserInputFilterInput
  ) {
    onCreateProjectUserInput(filter: $filter) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      input
      createdAt
      updatedAt
      proyectoProjectUserInputsId
      __typename
    }
  }
`;
export const onUpdateProjectUserInput = /* GraphQL */ `
  subscription OnUpdateProjectUserInput(
    $filter: ModelSubscriptionProjectUserInputFilterInput
  ) {
    onUpdateProjectUserInput(filter: $filter) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      input
      createdAt
      updatedAt
      proyectoProjectUserInputsId
      __typename
    }
  }
`;
export const onDeleteProjectUserInput = /* GraphQL */ `
  subscription OnDeleteProjectUserInput(
    $filter: ModelSubscriptionProjectUserInputFilterInput
  ) {
    onDeleteProjectUserInput(filter: $filter) {
      id
      etapa
      proyecto {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        institucionId
        organizacionId
        isCloneProject
        idProyectoFuente
        isEliminated
        createdAt
        updatedAt
        usuarioProyectosId
        institucionProyectosId
        __typename
      }
      proyectoId
      input
      createdAt
      updatedAt
      proyectoProjectUserInputsId
      __typename
    }
  }
`;
export const onCreateLog = /* GraphQL */ `
  subscription OnCreateLog($filter: ModelSubscriptionLogFilterInput) {
    onCreateLog(filter: $filter) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      detail
      action
      createdAt
      updatedAt
      usuarioLogsId
      __typename
    }
  }
`;
export const onUpdateLog = /* GraphQL */ `
  subscription OnUpdateLog($filter: ModelSubscriptionLogFilterInput) {
    onUpdateLog(filter: $filter) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      detail
      action
      createdAt
      updatedAt
      usuarioLogsId
      __typename
    }
  }
`;
export const onDeleteLog = /* GraphQL */ `
  subscription OnDeleteLog($filter: ModelSubscriptionLogFilterInput) {
    onDeleteLog(filter: $filter) {
      id
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      detail
      action
      createdAt
      updatedAt
      usuarioLogsId
      __typename
    }
  }
`;
export const onCreateInstitucion = /* GraphQL */ `
  subscription OnCreateInstitucion(
    $filter: ModelSubscriptionInstitucionFilterInput
  ) {
    onCreateInstitucion(filter: $filter) {
      id
      name
      tipo
      usuarios {
        nextToken
        __typename
      }
      proyectos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateInstitucion = /* GraphQL */ `
  subscription OnUpdateInstitucion(
    $filter: ModelSubscriptionInstitucionFilterInput
  ) {
    onUpdateInstitucion(filter: $filter) {
      id
      name
      tipo
      usuarios {
        nextToken
        __typename
      }
      proyectos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteInstitucion = /* GraphQL */ `
  subscription OnDeleteInstitucion(
    $filter: ModelSubscriptionInstitucionFilterInput
  ) {
    onDeleteInstitucion(filter: $filter) {
      id
      name
      tipo
      usuarios {
        nextToken
        __typename
      }
      proyectos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateWhitelistUser = /* GraphQL */ `
  subscription OnCreateWhitelistUser(
    $filter: ModelSubscriptionWhitelistUserFilterInput
  ) {
    onCreateWhitelistUser(filter: $filter) {
      id
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateWhitelistUser = /* GraphQL */ `
  subscription OnUpdateWhitelistUser(
    $filter: ModelSubscriptionWhitelistUserFilterInput
  ) {
    onUpdateWhitelistUser(filter: $filter) {
      id
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteWhitelistUser = /* GraphQL */ `
  subscription OnDeleteWhitelistUser(
    $filter: ModelSubscriptionWhitelistUserFilterInput
  ) {
    onDeleteWhitelistUser(filter: $filter) {
      id
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePerfil = /* GraphQL */ `
  subscription OnCreatePerfil($filter: ModelSubscriptionPerfilFilterInput) {
    onCreatePerfil(filter: $filter) {
      id
      nombre
      apellido
      tel
      cargo
      RBD
      colegio
      pais
      ciudad
      especialidades
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePerfil = /* GraphQL */ `
  subscription OnUpdatePerfil($filter: ModelSubscriptionPerfilFilterInput) {
    onUpdatePerfil(filter: $filter) {
      id
      nombre
      apellido
      tel
      cargo
      RBD
      colegio
      pais
      ciudad
      especialidades
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePerfil = /* GraphQL */ `
  subscription OnDeletePerfil($filter: ModelSubscriptionPerfilFilterInput) {
    onDeletePerfil(filter: $filter) {
      id
      nombre
      apellido
      tel
      cargo
      RBD
      colegio
      pais
      ciudad
      especialidades
      usuario {
        id
        name
        email
        institucionId
        creditosId
        perfilId
        isActive
        createdAt
        updatedAt
        institucionUsuariosId
        __typename
      }
      usuarioId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateChatAgentSession = /* GraphQL */ `
  subscription OnCreateChatAgentSession(
    $filter: ModelSubscriptionChatAgentSessionFilterInput
  ) {
    onCreateChatAgentSession(filter: $filter) {
      id
      userId
      sessionName
      proyectoId
      resultadoId
      modelName
      modelId
      totalTokens
      creditosDescontados
      conversionFactor
      conversionUnit
      mensajes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateChatAgentSession = /* GraphQL */ `
  subscription OnUpdateChatAgentSession(
    $filter: ModelSubscriptionChatAgentSessionFilterInput
  ) {
    onUpdateChatAgentSession(filter: $filter) {
      id
      userId
      sessionName
      proyectoId
      resultadoId
      modelName
      modelId
      totalTokens
      creditosDescontados
      conversionFactor
      conversionUnit
      mensajes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteChatAgentSession = /* GraphQL */ `
  subscription OnDeleteChatAgentSession(
    $filter: ModelSubscriptionChatAgentSessionFilterInput
  ) {
    onDeleteChatAgentSession(filter: $filter) {
      id
      userId
      sessionName
      proyectoId
      resultadoId
      modelName
      modelId
      totalTokens
      creditosDescontados
      conversionFactor
      conversionUnit
      mensajes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateChatAgentMessage = /* GraphQL */ `
  subscription OnCreateChatAgentMessage(
    $filter: ModelSubscriptionChatAgentMessageFilterInput
  ) {
    onCreateChatAgentMessage(filter: $filter) {
      id
      chatSessionId
      actor
      instruction
      content
      tokensUsed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateChatAgentMessage = /* GraphQL */ `
  subscription OnUpdateChatAgentMessage(
    $filter: ModelSubscriptionChatAgentMessageFilterInput
  ) {
    onUpdateChatAgentMessage(filter: $filter) {
      id
      chatSessionId
      actor
      instruction
      content
      tokensUsed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteChatAgentMessage = /* GraphQL */ `
  subscription OnDeleteChatAgentMessage(
    $filter: ModelSubscriptionChatAgentMessageFilterInput
  ) {
    onDeleteChatAgentMessage(filter: $filter) {
      id
      chatSessionId
      actor
      instruction
      content
      tokensUsed
      createdAt
      updatedAt
      __typename
    }
  }
`;
